var Slider = function() {

	this.init = function() {

		this.slider();

	}

	if ($(window).width() < 768) {
		
		$("[data-component='article-slider'] .holder").each(function(){
			$(this).attr('style', 'background-image: url( ' + $(this).data("mobile-background") + ' )');
		});
	}

	this.slider = function(){

		$('[data-component="article-slider"] .div-to-slide').slick({
			centerMode: true,
			slidesToShow: 1,
			centerPadding: '120px',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						centerPadding: '60px',
						arrows: false
					}
				},
				{
					breakpoint: 768,
					settings: {
						centerPadding: '20px',
						arrows: false
					}
				}
			]
		});

	}

	return this.init();

}
